import i18n from "./i18n"; //引入语言插件
import store from "@/store/store";
import { Message, Notification } from "element-ui"; //引入提示框
import CryptoJS from "crypto-js/crypto-js";
const key = CryptoJS.enc.Utf8.parse("wind1010"); // 密钥 后端提供
const iv = CryptoJS.enc.Utf8.parse(""); // 偏移量

const tools = {
  // 腾讯地图key
  txMapKey: "YO6BZ-XJSKT-URRXZ-VZRRL-2NXKS-XUFND",
  // 复制函数
  async copy(val) {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard 向剪贴板写文本
      Message.success(i18n.t("user.copysuccess"));
      return navigator.clipboard.writeText(val);
    } else {
      // 创建text area
      const textArea = document.createElement("textarea");
      textArea.value = val;
      // 使text area不在viewport，同时设置不可见
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      Message.success(i18n.t("user.copysuccess"));
      return new Promise((res, rej) => {
        // 执行复制命令并移除文本框
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  },
  /**
   * AES加密 ：字符串 key iv  返回base64
   */
  Encrypt(word) {
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  },
  /**
   * AES 解密 ：字符串 key iv  返回base64
   *  */
  Decrypt(word) {
    const base64 = CryptoJS.enc.Base64.parse(word);
    const src = CryptoJS.enc.Base64.stringify(base64);

    const decrypt = CryptoJS.AES.decrypt(src, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt);
  },
  /**
   * 置灰权限函数
   * */
  IsGrayModule(bs) {
    const all_permission = "*:*:*";
    // const all_permission = "";
    const permissions = store.state.permissions;
    if (all_permission == permissions) {
      return false;
    }
    let bol = permissions.some(item => {
      return item == bs;
    });
    return !bol;
  }
};

export default tools;
